import axios from "axios";
const token     = appObj.apiNonce;
const baseUrl   = appObj.baseEndpoint;

const httpService = axios.create({
    baseURL: baseUrl,
    headers:{
        "Content-type"  : "application/json",
        "X-WP-Nonce"    : token,
    }
})

export default httpService;